import {Component, inject, OnInit} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../services/auth.service";
import {NotificationService} from "../../services/notification.service";
import {Router} from "@angular/router";
import {UserManagementService} from "../../services/user-management.service";
import {AccountTypeEnum} from "../../common/interfaces/global-interfaces";
import {StorageService} from "../../services/storage.service";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {

  form: FormGroup;
  hide = true;
  loading = false;
  private readonly fb: FormBuilder = inject(FormBuilder)
  private readonly authService: AuthService = inject(AuthService)
  private readonly notificationService: NotificationService = inject(NotificationService);
  private readonly router: Router = inject(Router);
  private readonly uaaService: UserManagementService = inject(UserManagementService)
  private readonly storageService = inject(StorageService);

  isProduction = environment.production;

  constructor() {
  }

  ngOnInit() {
    this.form = this.fb.group({
      username: [null, Validators.required],
      password: [null, Validators.required],
    });
  }

  async login(formValue) {

    this.loading = true;

    try {
      // login now
      const authTokenModel = await this.authService.login(formValue);

      if (authTokenModel?.success) {
        await this.uaaService.authRole();
        const accountType: AccountTypeEnum = this.storageService.get('accountType')

        await this.router.navigate(['', 'landing']);


        // switch (accountType) {
        //   case AccountTypeEnum.GGRMIS:
        //     await this.router.navigate(['', 'manage', 'program-management']);
        //     break;
        //   case AccountTypeEnum.ADMIN:
        //     await this.router.navigate(['', 'manage', 'system-configuration']);
        //     break;
        //   case AccountTypeEnum.SA || AccountTypeEnum.NSA:
        //     if (this.storageService.get('userTypeT') === 'SA_ADMIN') {
        //       await this.router.navigate(['', 'manage', 'implementor-settings']);
        //     } else {
        //       await this.router.navigate(['', 'manage', 'implementor']);
        //     }
        //     break;
        // }
      } else {
        this.notificationService.errorMessage(authTokenModel?.massage)
      }
    } catch (e) {
      //console.error('Error fetching auth user:', e.message);
    }

    this.loading = false;
  }
}
